var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2848)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0791 18.86C17.0791 18.11 17.1991 17.47 17.4391 16.94C17.6791 16.4 18.1091 15.805 18.7291 15.155C19.3391 14.505 19.7591 13.95 19.9891 13.49C20.2291 13.03 20.3491 12.55 20.3491 12.05C20.3491 11.6 20.2741 11.29 20.1241 11.12C19.9841 10.94 19.7741 10.85 19.4941 10.85C18.9241 10.85 18.6391 11.195 18.6391 11.885V13.01H17.0791V11.99C17.0791 11.14 17.2891 10.49 17.7091 10.04C18.1291 9.58 18.7391 9.35 19.5391 9.35C20.3391 9.35 20.9491 9.58 21.3691 10.04C21.7891 10.49 21.9991 11.14 21.9991 11.99C21.9991 12.63 21.8441 13.255 21.5341 13.865C21.2341 14.475 20.7091 15.175 19.9591 15.965C19.4691 16.485 19.1391 16.91 18.9691 17.24C18.7991 17.56 18.7141 17.905 18.7141 18.275V18.5H21.8491V20H17.0791V18.86ZM25.875 18.095H22.725V16.595L25.725 9.5H27.525V16.595H28.305V18.095H27.525V20H25.875V18.095ZM25.875 16.595V12.5H25.845L24.225 16.595H25.875Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2848",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2848",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.cd3584ecb98ed78855f29dcb03e8ab05.svg";
export { ForwardRef as ReactComponent };